import axios from '../axios'

// 講師一覧（admin・担当コース数/担当生徒数つき）
const getTeachersApi = async () => {
  return await axios.get('api/lms/teachers')
}

export default getTeachersApi
